
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      // layout container magic
      // grid template columns - named
      styles.gridTemplateColumns = `[full-start] minmax(32px,1fr) [container-start] 0 [container-left-start] minmax(auto,calc(${this.$store.state.app.containerWidth}px /2)) [container-left-end] 0 [container-right-start] minmax(auto,calc(${this.$store.state.app.containerWidth}px /2)) [container-right-end] 0 [container-end] minmax(32px,1fr) [full-end]`

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
    leftColumnStyles() {
      const styles = {}

      styles.gridColumn = this.getBreakpointValue(this.blok.leftColumnSpan)
      styles.placeSelf = this.getBreakpointValue(this.blok.leftColumnPlaceSelf)

      return styles
    },
    rightColumnStyles() {
      const styles = {}

      styles.gridColumn = this.getBreakpointValue(this.blok.rightColumnSpan)
      styles.placeSelf = this.getBreakpointValue(this.blok.rightColumnPlaceSelf)

      return styles
    },
  },
}
